<script lang="ts">
  export let value: string
  export let label: string
</script>

<div class="date-picker">
  <div class="label">
    {label}
  </div>

  <input 
    type="time" 
    bind:value 
  />
</div>

<style lang="scss">
  .date-picker {
    width: 100%;
    margin-bottom: 16px;

    .label {
      font-weight: 600;
      line-height: 20px;
      color: #30333D;
      margin-bottom: 8px;
    }

    input {
      height: 49px;
      border: 1px solid #B6C8F9;
      padding: 12px;
      text-transform: uppercase;
      border-radius: 4px;
      line-height: 20px;
      color: #22252C;
      outline: none;
      width: 100%;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
</style>